import { useMutation } from 'react-query'

import { request } from '../utils/api'
import { HTTPMethod } from '../utils/api.types'
import type { Response } from '../utils/api.types'

type UpdateSpeakerRequest = {
  live_speaker_id: number
  request_status: RequestStatus
}

type UpdateSpeakerResponse = Response

type RequestStatus = 'requested' | 'approved' | 'denied' | 'expired'

type UpdateSpeakerParams = {
  speakerId: number
  requestStatus: RequestStatus
}

function updateSpeaker(params: UpdateSpeakerParams) {
  return request<UpdateSpeakerRequest, UpdateSpeakerResponse>({
    url: '/api/2/live/speaker/update',
    method: HTTPMethod.POST,
    data: {
      live_speaker_id: params.speakerId,
      request_status: params.requestStatus,
    },
  })
}

function useUpdateSpeakerMutation() {
  return useMutation(updateSpeaker)
}

export { updateSpeaker, useUpdateSpeakerMutation }
